import { Component, EventEmitter, Input, Output, ElementRef, ViewChild, AfterViewInit, SimpleChanges, OnChanges } from '@angular/core';

import 'ion-rangeslider';
import { IonRangeSliderOptions } from 'ion-rangeslider';
import * as _ from 'lodash';

@Component({
  selector: 'range-slider',
  // template: require('./range-slider.component.html'),
  template: `
    <input #slider type="text" class="js-range-slider" name="my_range" value="" />
  `
})
export class RangeSliderComponent implements AfterViewInit, OnChanges {

  @ViewChild('slider') el: ElementRef;
  @Input('conf') conf: IonRangeSliderOptions = {};

  @Output('change') onChange = new EventEmitter<any>();
  @Output('start') onStart = new EventEmitter<any>();
  @Output('finish') onFinish = new EventEmitter<any>();
  @Output('update') onUpdate = new EventEmitter<any>();


  constructor() { }



  private prettify(n) {
    let sec_num: any = parseInt(n, 10); // don't forget the second param
    let hours: any = Math.floor(sec_num / 3600);
    let minutes: any = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds: any = sec_num - (hours * 3600) - (minutes * 60);
    let milisec: any = n;

    if (hours < 10) { hours = "0" + hours; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
    if (milisec < 10) { milisec = "0" + milisec; }
    return hours + ':' + minutes + ':' + seconds + '.' + (milisec % 1).toFixed(1).substring(2);
  }

  private get defaultConf(): IonRangeSliderOptions {
    // const limit_filter = (data) => {
    //   let duration = data.to - data.from

    //   if (duration == 0) {
    //     $("#d-pscreen").css('opacity', '1').css('cursor', 'pointer')
    //     $("#d-file").css('opacity', '0.5').css('cursor', 'no-drop')
    //     $("#d-audio").css('opacity', '0.5').css('cursor', 'no-drop')
    //     $("#d-gif").css('opacity', '0.5').css('cursor', 'no-drop')
    //   } else {
    //     $("#d-pscreen").css('opacity', '0.5').css('cursor', 'no-drop')
    //     $("#d-file").css('opacity', '1').css('cursor', 'pointer')
    //     $("#d-audio").css('opacity', '1').css('cursor', 'pointer')
    //     $("#d-gif").css('opacity', '1').css('cursor', 'pointer')
    //   }

    //   if (duration >= 0.1 && duration <= 10) {
    //     $("#d-gif").css('opacity', '1').css('cursor', 'pointer')
    //   } else {
    //     $("#d-gif").css('opacity', '0.5').css('cursor', 'no-drop')
    //   }

    //   const max_interval = 1000;
    //   let percentage = duration / max_interval * 100
    //   let color = hsl_col_perc(percentage, 0, 100)
    //   $("#ytduration").text(prettify(duration)).css('color', color)
    // }

    // const prettify = (n) => {
    //   let sec_num: any = parseInt(n, 10); // don't forget the second param
    //   let hours: any = Math.floor(sec_num / 3600);
    //   let minutes: any = Math.floor((sec_num - (hours * 3600)) / 60);
    //   let seconds: any = sec_num - (hours * 3600) - (minutes * 60);
    //   let milisec: any = n;

    //   if (hours < 10) { hours = "0" + hours; }
    //   if (minutes < 10) { minutes = "0" + minutes; }
    //   if (seconds < 10) { seconds = "0" + seconds; }
    //   if (milisec < 10) { milisec = "0" + milisec; }
    //   return hours + ':' + minutes + ':' + seconds + '.' + (milisec % 1).toFixed(1).substring(2);
    // }


    // const hsl_col_perc = (percent, start, end) => {
    //   var a = percent / 100,
    //     b = (start - end) * a,
    //     c = b + end;
    //   // Return a CSS HSL string
    //   return 'hsl(' + c + ', 100%, 50%)';
    // }

    const { prettify } = this;
    return {
      type: "double",
      skin: "round",
      min: 0,
      max: 100, //duration
      // max_interval: 10, // adgroup max duration
      step: 1,
      from: 0,
      to: 10,
      drag_interval: true,
      grid: false,
      grid_snap: true,
      onStart: (data) => this.onStart.emit(data),
      onChange: (data) => this.onChange.emit(data),
      onFinish: (data) => this.onFinish.emit(data),
      onUpdate: (data) => this.onUpdate.emit(data),
      // prettify,
      // onStart: function (data) {
      //     limit_filter(data)
      // },
      // onChange: function (data) {
      //     limit_filter(data)
      // },
      // onFinish: function (data) {
      //     if (data.to > data.from) {
      //         player.loadVideoById({
      //             videoId: player.getVideoData()['video_id'],
      //             startSeconds: data.from,
      //             endSeconds: data.to
      //         });
      //     }
      // },
      // onUpdate: function (data) {
      // }
    }
  }

  get $rangeSlider() {
    return $(this.el.nativeElement).data("ionRangeSlider");
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    let newConf = _.assign({}, this.defaultConf, this.conf)    
    $(this.el.nativeElement).ionRangeSlider(newConf);
  }

  ngOnChanges(changes: SimpleChanges) {    
    if (changes.conf) {
      // setTimeout(() => {
        if (this.$rangeSlider) { 
          // console.log('slider changes', changes.conf.currentValue)
          this.$rangeSlider.update(changes.conf.currentValue)          
          // this.$rangeSlider.update(_.pick(changes.conf.currentValue, ['max', 'min', 'from', 'to', 'max_interval'])); 
        }
      // }, 250);
    }
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/common/utils/range-slider.component.ts